export default {
  name: 'XYButtonV2',
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  }
};